module.exports = __webpack_public_path__ + "site/img/161.c75bcc47.jpg";